export const BRANDING = "BRANDING";
export const TRANSLATIONS = "TRANSLATIONS";
export const LOCALE = "LOCALE";
export const PROCEED_UNSUPPORTED = "PROCEED_UNSUPPORTED";
export const NEXT_DEPRECATED_WARNING_DATE = "NEXT_DEPRECATED_WARNING_DATE";
export const DATA_CACHE = "DATA_CACHE";
